// # General Routes - Shared Features
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../ProtectedRoute';

// # Import notifications component
import UserNotificationsPage from '../../systems/notifications/components/usr_notif_page';

// # Import events component
import Events from '../../general/extra_content/events/events';
import MyMeetings from '../../general/extra_content/events/my_meetings/my_meetings';

// # Import notes components
import MyNotes from '../../general/notes/my_notes';
import ChapterNotes from '../../general/notes/chapter_notes';
import NotePage from '../../general/notes/notepage';

// # Import flashcard components
import MyFlashcards from '../../general/flashcards/my_flashcards';
import ChapterFlashcards from '../../general/flashcards/chapter_flashcards';
import FlashcardHome from '../../general/flashcards/tabs/flashcard_home';
import FlashcardBrowser from '../../general/flashcards/tabs/flashcard_browser';
import FlashcardPreferences from '../../general/flashcards/tabs/flashcard_preferences';

// # Import blog components
import AdminPosts from '../../general/blog/articles/articles_mn';
import ArticleView from '../../general/blog/articles/article_view';
import QA from '../../general/blog/qa';
import Discussions from '../../general/blog/discussions';
import Match from '../../general/blog/discuss/match';
import LifeUS from '../../general/blog/discuss/life_us';
import Specialty from '../../general/blog/discuss/specialty';
import MedSchools from '../../general/blog/discuss/medschools';

// # Import bookmark components
import MyBookmarks from '../../general/bookmarks/my_bookmarks';
import BookmarkPage from '../../general/bookmarks/bookmark_page';
import BookmarkCalendar from '../../general/bookmarks/bookmark_calendar';

// # Import support component
import UserSupport from '../../systems/support/user_support';

// # Import labs component
import Labs from '../../general/extra_content/labs/labs';

// # Import community components
import TakeNotes from '../../general/extra_content/take_notes';
import Guide from '../../general/extra_content/guide/guide';
import AnkiGuide from '../../general/extra_content/guide/guide_anki';
import LibrariesGuide from '../../general/extra_content/guide/guide_libraries';
import QuestionsGuide from '../../general/extra_content/guide/guide_questions';
import ExamDayGuide from '../../general/extra_content/guide/guide_exam_day';
import Experiences from '../../general/extra_content/experiences/experiences';
import TakeBreak from '../../general/extra_content/take_break/take_break';
import Roadmaps from '../../general/extra_content/roadmaps/roadmaps';
import Updates from '../../general/extra_content/updates/updates';
import Rotations from '../../general/extra_content/rotations/rotations';
import RotationsGuide from '../../general/extra_content/rotations/rotation_main';
import QuranPage from '../../general/extra_content/take_break/QuranPage';

// # Import feedback components
import UserFeedback from '../../systems/feedbacks/feedback_user';
import AdminFeedback from '../../systems/feedbacks/feedback_admin';

// # Import review components
import UserReview from '../../systems/reviews/user_review';

// # Import extras components
import Gallery from '../../general/extra_content/gallery/gallery';
import Clinical from '../../general/extra_content/clinical/clinical';
import Research from '../../general/extra_content/research/research';
import OET from '../../general/extra_content/oet/oet';

const GeneralRoutes = () => {
  return (
    <Routes>
      {/* # Notifications Route */}
      <Route path="/notifications" element={
        <ProtectedRoute>
          <UserNotificationsPage />
        </ProtectedRoute>
      } />

      {/* # Notes System Routes */}
      <Route path="/notes" element={
        <ProtectedRoute>
          <MyNotes />
        </ProtectedRoute>
      } />
      <Route path="/notes/:stepId/:chapterId" element={
        <ProtectedRoute>
          <ChapterNotes />
        </ProtectedRoute>
      } />
      <Route path="/notes/:stepId/:chapterId/create" element={
        <ProtectedRoute>
          <NotePage />
        </ProtectedRoute>
      } />
      <Route path="/notes/:stepId/:chapterId/edit/:noteId" element={
        <ProtectedRoute>
          <NotePage />
        </ProtectedRoute>
      } />
      <Route path="/notes/general" element={
        <ProtectedRoute>
          <MyNotes type="general" />
        </ProtectedRoute>
      } />

      {/* # Labs Routes */}
      <Route path="/labs" element={
        <ProtectedRoute>
          <Labs />
        </ProtectedRoute>
      } />

      {/* # Flashcard System Routes */}
      <Route path="/flashcards/*" element={
        <ProtectedRoute>
          <MyFlashcards />
        </ProtectedRoute>
      } />
      <Route path="/flashcards/:stepId/:chapterId" element={
        <ProtectedRoute>
          <ChapterFlashcards />
        </ProtectedRoute>
      } />
      <Route path="/flashcards/general" element={
        <ProtectedRoute>
          <MyFlashcards type="general" />
        </ProtectedRoute>
      } />

      {/* # Blog System Routes */}
      <Route path="/blog/articles" element={
        <ProtectedRoute>
          <AdminPosts />
        </ProtectedRoute>
      } />
      <Route path="/articles/:articleId" element={
        <ProtectedRoute>
          <ArticleView />
        </ProtectedRoute>
      } />
      <Route path="/blog/qa" element={
        <ProtectedRoute>
          <QA />
        </ProtectedRoute>
      } />
      <Route path="/blog/qa/:questionId" element={
        <ProtectedRoute>
          <QA />
        </ProtectedRoute>
      } />
      <Route path="/blog/discussions" element={
        <ProtectedRoute>
          <Discussions />
        </ProtectedRoute>
      } />
      <Route path="/blog/discussions/:discussionId" element={
        <ProtectedRoute>
          <Discussions />
        </ProtectedRoute>
      } />
      {/* # Discussion Topics Routes */}
      <Route path="/blog/discussions/match" element={
        <ProtectedRoute>
          <Match />
        </ProtectedRoute>
      } />
      <Route path="/blog/discussions/life-us" element={
        <ProtectedRoute>
          <LifeUS />
        </ProtectedRoute>
      } />
      <Route path="/blog/discussions/specialty" element={
        <ProtectedRoute>
          <Specialty />
        </ProtectedRoute>
      } />
      <Route path="/blog/discussions/medical-school" element={
        <ProtectedRoute>
          <MedSchools />
        </ProtectedRoute>
      } />

      {/* # Support System Routes */}
      <Route path="/support" element={
        <ProtectedRoute>
          <UserSupport />
        </ProtectedRoute>
      } />
      <Route path="/support/:ticketId" element={
        <ProtectedRoute>
          <UserSupport />
        </ProtectedRoute>
      } />

      {/* # Bookmark System Routes */}
      <Route path="/bookmarks" element={
        <ProtectedRoute>
          <MyBookmarks isAdmin={false} />
        </ProtectedRoute>
      } />
      <Route path="/bookmarks/calendar" element={
        <ProtectedRoute>
          <BookmarkCalendar isAdmin={false} />
        </ProtectedRoute>
      } />
      <Route path="/bookmarks/general" element={
        <ProtectedRoute>
          <BookmarkPage type="general" isAdmin={false} />
        </ProtectedRoute>
      } />
      <Route path="/bookmarks/step1" element={
        <ProtectedRoute>
          <BookmarkPage type="step1" isAdmin={false} />
        </ProtectedRoute>
      } />
      <Route path="/bookmarks/step1/:chapterId" element={
        <ProtectedRoute>
          <BookmarkPage type="step1" isAdmin={false} />
        </ProtectedRoute>
      } />
      <Route path="/bookmarks/step2" element={
        <ProtectedRoute>
          <BookmarkPage type="step2" isAdmin={false} />
        </ProtectedRoute>
      } />
      <Route path="/bookmarks/step2/:chapterId" element={
        <ProtectedRoute>
          <BookmarkPage type="step2" isAdmin={false} />
        </ProtectedRoute>
      } />

      {/* # Community Routes - User Access */}
      {/* Taking Notes Routes */}
      <Route path="/community/notes" element={
        <ProtectedRoute>
          <TakeNotes />
        </ProtectedRoute>
      } />
      <Route path="/community/notes/:category" element={
        <ProtectedRoute>
          <TakeNotes />
        </ProtectedRoute>
      } />
      <Route path="/community/notes/:category/:noteId" element={
        <ProtectedRoute>
          <TakeNotes />
        </ProtectedRoute>
      } />

      {/* Experiences Route */}
      <Route path="/community/experiences" element={
        <ProtectedRoute>
          <Experiences />
        </ProtectedRoute>
      } />

      {/* Guide Routes */}
      <Route path="/community/guide" element={
        <ProtectedRoute>
          <Guide />
        </ProtectedRoute>
      } />
      <Route path="/community/guide/anki" element={
        <ProtectedRoute>
          <AnkiGuide />
        </ProtectedRoute>
      } />
      <Route path="/community/guide/libraries" element={
        <ProtectedRoute>
          <LibrariesGuide />
        </ProtectedRoute>
      } />
      <Route path="/community/guide/questions" element={
        <ProtectedRoute>
          <QuestionsGuide />
        </ProtectedRoute>
      } />
      <Route path="/community/guide/exam-day" element={
        <ProtectedRoute>
          <ExamDayGuide />
        </ProtectedRoute>
      } />

      {/* Take a Break Routes */}
      <Route path="/community/break" element={
        <ProtectedRoute>
          <TakeBreak />
        </ProtectedRoute>
      } />
      <Route path="/community/break/quran" element={
        <ProtectedRoute>
          <QuranPage />
        </ProtectedRoute>
      } />
      <Route path="/community/break/:category" element={
        <ProtectedRoute>
          <TakeBreak />
        </ProtectedRoute>
      } />
      <Route path="/community/break/:category/:contentId" element={
        <ProtectedRoute>
          <TakeBreak />
        </ProtectedRoute>
      } />

      {/* Roadmaps Routes */}
      <Route path="/community/roadmaps" element={
        <ProtectedRoute>
          <Roadmaps />
        </ProtectedRoute>
      } />
      <Route path="/community/roadmaps/:stepId" element={
        <ProtectedRoute>
          <Roadmaps />
        </ProtectedRoute>
      } />
      <Route path="/community/roadmaps/:stepId/:section" element={
        <ProtectedRoute>
          <Roadmaps />
        </ProtectedRoute>
      } />

      {/* Updates Routes */}
      <Route path="/community/updates" element={
        <ProtectedRoute>
          <Updates />
        </ProtectedRoute>
      } />
      <Route path="/community/updates/:category" element={
        <ProtectedRoute>
          <Updates />
        </ProtectedRoute>
      } />
      <Route path="/community/updates/:category/:updateId" element={
        <ProtectedRoute>
          <Updates />
        </ProtectedRoute>
      } />

      {/* Clinical Rotations Route */}
      <Route path="/community/rotations" element={
        <ProtectedRoute>
          <Rotations />
        </ProtectedRoute>
      } />
      <Route path="/community/rotations/usce" element={
        <ProtectedRoute>
          <RotationsGuide />
        </ProtectedRoute>
      } />

      {/* # Feedback Routes */}
      <Route path="/feedback" element={
        <ProtectedRoute>
          <UserFeedback />
        </ProtectedRoute>
      } />

      {/* # Review Routes */}
      <Route path="/write-review" element={
        <ProtectedRoute>
          <UserReview />
        </ProtectedRoute>
      } />

      {/* # Events Routes */}
      <Route path="/community/events" element={
        <ProtectedRoute>
          <Events />
        </ProtectedRoute>
      } />
      <Route path="/community/events/meetings" element={
        <ProtectedRoute>
          <MyMeetings />
        </ProtectedRoute>
      } />
      <Route path="/admin/community/events" element={
        <ProtectedRoute adminOnly={true}>
          <Events />
        </ProtectedRoute>
      } />

      {/* # Admin versions of the same routes */}
      <Route path="/admin/notes" element={
        <ProtectedRoute adminOnly={true}>
          <MyNotes />
        </ProtectedRoute>
      } />
      <Route path="/admin/notes/:stepId/:chapterId" element={
        <ProtectedRoute adminOnly={true}>
          <ChapterNotes />
        </ProtectedRoute>
      } />
      <Route path="/admin/notes/:stepId/:chapterId/create" element={
        <ProtectedRoute adminOnly={true}>
          <NotePage />
        </ProtectedRoute>
      } />
      <Route path="/admin/notes/:stepId/:chapterId/edit/:noteId" element={
        <ProtectedRoute adminOnly={true}>
          <NotePage />
        </ProtectedRoute>
      } />
      <Route path="/admin/flashcards" element={
        <ProtectedRoute adminOnly={true}>
          <MyFlashcards />
        </ProtectedRoute>
      } />
      <Route path="/admin/flashcards/:stepId/:chapterId" element={
        <ProtectedRoute adminOnly={true}>
          <ChapterFlashcards />
        </ProtectedRoute>
      } />
      <Route path="/admin/bookmarks" element={
        <ProtectedRoute adminOnly={true}>
          <MyBookmarks isAdmin={true} />
        </ProtectedRoute>
      } />
      <Route path="/admin/bookmarks/calendar" element={
        <ProtectedRoute adminOnly={true}>
          <BookmarkCalendar />
        </ProtectedRoute>
      } />
      <Route path="/admin/bookmarks/:type" element={
        <ProtectedRoute adminOnly={true}>
          <BookmarkPage isAdmin={true} />
        </ProtectedRoute>
      } />
      <Route path="/admin/bookmarks/:type/:chapterId" element={
        <ProtectedRoute adminOnly={true}>
          <BookmarkPage isAdmin={true} />
        </ProtectedRoute>
      } />
      <Route path="/admin/rotations" element={
        <ProtectedRoute adminOnly={true}>
          <Rotations />
        </ProtectedRoute>
      } />
      <Route path="/admin/rotations/usce" element={
        <ProtectedRoute adminOnly={true}>
          <RotationsGuide />
        </ProtectedRoute>
      } />

      {/* # Extras Routes */}
      <Route path="/extras/gallery" element={
        <ProtectedRoute>
          <Gallery />
        </ProtectedRoute>
      } />
      <Route path="/extras/clinical" element={
        <ProtectedRoute>
          <Clinical />
        </ProtectedRoute>
      } />
      <Route path="/extras/research" element={
        <ProtectedRoute>
          <Research />
        </ProtectedRoute>
      } />
      <Route path="/extras/oet" element={
        <ProtectedRoute>
          <OET />
        </ProtectedRoute>
      } />

      {/* # Admin blog routes */}
      <Route path="/admin/blog/articles" element={
        <ProtectedRoute adminOnly={true}>
          <AdminPosts />
        </ProtectedRoute>
      } />
      <Route path="/admin/articles/:articleId" element={
        <ProtectedRoute adminOnly={true}>
          <ArticleView />
        </ProtectedRoute>
      } />
    </Routes>
  );
};

export default GeneralRoutes;
